<template>
  <div>
    <media :query="{minWidth: 1440}">
      <div
        class="map-continent"
        :class="{ 'map-continent--vertical' : region.mode === 'vertical' }"
        :style="{ 'left': `${region.left}px`, 'top': `${region.top}px`}"
      >
        <div class="map-continent__name">
          <a
            class="map-continent__name-anchor"
            @click="$emit('click:title', region)"
          >
            {{ region.name }} >
          </a>
        </div>
        <ul
          v-if="region.items && computedItems.length"
          class="map-continent__items"
        >
          <li
            v-for="(item, index) in computedItems"
            v-show="index < 9"
            :key="`item-${index}`"
            class="map-continent__item"
          >
            <a
              class="map-continent__anchor"
              :title="item.title"
              @click="handleClickItem($event, item, region.direction)"
            >
              <img
                :src="`${imagesHost}${item.thumbnailImage}`"
                class="map-continent__thumbnail"
                alt=""
              >
            </a>
          </li>
          <li
            v-if="computedItems.length > 9"
            :key="`item-more`"
            class="map-continent__item"
          >
            <a
              class="map-continent__more"
              @click="$emit('click:title', region)"
            />
          </li>
        </ul>
      </div>
    </media>
    <media :query="{minWidth: 1081, maxWidth: 1439}">
      <div
        class="map-continent"
        :class="{ 'map-continent--vertical' : region.mode === 'vertical' }"
        :style="{ 'left': `${region.leftVw}vw`, 'top': `${region.topVw}vw`}"
      >
        <div class="map-continent__name">
          <a
            class="map-continent__name-anchor"
            @click="$emit('click:title', region)"
          >
            {{ region.name }} >
          </a>
        </div>
        <ul
          v-if="region.items && computedItems.length"
          class="map-continent__items"
        >
          <li
            v-for="(item, index) in computedItems"
            v-show="index < 9"
            :key="`item-${index}`"
            class="map-continent__item"
          >
            <a
              class="map-continent__anchor"
              :title="item.title"
              @click="handleClickItem($event, item, region.direction)"
            >
              <img
                :src="`${imagesHost}${item.thumbnailImage}`"
                class="map-continent__thumbnail"
                alt=""
              >
            </a>
          </li>
          <li
            v-if="computedItems.length > 9"
            :key="`item-more`"
            class="map-continent__item"
          >
            <a
              class="map-continent__more"
              @click="$emit('click:title', region)"
            />
          </li>
        </ul>
      </div>
    </media>
  </div>
</template>

<script>
import Media from 'vue-media'
export default {
  name: 'MapContinent',
  components: {
    Media
  },
  filters: {
    
  },
  props: {
    region: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: String,
      required: true,
    },
    vertical: {
      type: String,
      required: true,
    },
    productCategory: {
      type: String,
      required: true,
    },
  },
  computed: {
    imagesHost() {
      if (window.location.host.indexOf('www.') > -1) {
        return 'https://image.lgcommercialdisplay.com'
      } else {
        return 'https://stg.lgcommercialdisplay.com'
      }
    },
    computedItems() {
      return this.region.items.filter((item) => {
        if ((this.viewMode === 'region') || (this.viewMode === 'vertical' && item.vertical === this.vertical)) {
          return item
        }
        else if (this.viewMode === 'product') {
          let hasFilterCategory = false
          item.recommendedProduct.forEach(product => {
            if (product.productCategory1 === this.productCategory) {
              hasFilterCategory = true
            }
          })
          if (hasFilterCategory) {
            return item
          }
        }
      });
    }
  },
  methods: {
    handleClickItem($event, item, direction) {
      this.$emit('click:item', $event.target, item, direction)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/scss/function.scss';

$map-continent: '.map-continent';
#{$map-continent} {
  position: absolute;
  width: 480px;
  left: 0;
  top: 0;
  @media only screen and (max-width: 1439px) and (min-width: 1081px){
    width: calc(((480 / 1440) * 100) * 1vw);
  }
  &--vertical {
    width: 210px;
    @media only screen and (max-width: 1439px) and (min-width: 1081px){
      width: calc(((210 / 1440) * 100) * 1vw);
    }
    #{$map-continent}__items {
      display: inline-flex;
      width: 210px;
      flex-wrap: wrap;
      @media only screen and (max-width: 1439px) and (min-width: 1081px){
        width: calc(((210 / 1440) * 100) * 1vw);
      }
    }
    #{$map-continent}__item {
      float: none;
    }
  }
  &__name {
    margin-left: -26px;
    margin-bottom: 14px;
    @media only screen and (max-width: 1439px) and (min-width: 1081px){
      margin-left: calc(((-26 / 1440) * 100) * 1vw);;
      margin-bottom: calc(((14 / 1440) * 100) * 1vw);;
    }
  }
  &__name-anchor {
    font-size: 22px;
    color: #333;
    font-weight: 400;
    @media only screen and (max-width: 1439px) and (min-width: 1081px){
      font-size: calc(((22 / 1440) * 100) * 1vw);
    }
  }
  &__name-anchor:hover {
    cursor: pointer;
  }
  &__name-anchor:hover {
    color: #fd312e;
  }
  &__items {
    margin-left: -8px;
    @media only screen and (max-width: 1439px) and (min-width: 1081px){
      margin-left: calc(((-8 / 1440) * 100) * 1vw);
    }
  }
  &__item {
    position: relative;
    float: left;
    margin-left: 8px;
    margin-top: 8px;
    width: 78px;
    height: 45px;
    @media only screen and (max-width: 1439px) and (min-width: 1081px){
      width: calc(((78 / 1440) * 100) * 1vw);
      height: calc(((45 / 1440) * 100) * 1vw);
      margin-left: calc(((8 / 1440) * 100) * 1vw);
      margin-top: calc(((8 / 1440) * 100) * 1vw);
    }
    #{$map-continent}__anchor:hover {
      position: absolute;
      z-index: 1;
      cursor: pointer;
      transform: scale(1.26);
    }
  }
  &__anchor {
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 5px;
    box-shadow: 0px 2px 9.6px 0.4px rgba(0, 0, 0, 0.35);
    transition: transform 0.2s linear;
    font-size: 0;
  }
  &__more {
    position: absolute;
    display: block;
    width: 23px;
    height: 23px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #6e6e6e;
    border-radius: 12px;
    box-shadow: 0px 2px 9.6px 0.4px rgba(0, 0, 0, 0.35);
    transition: all 0.2s linear;
    cursor: pointer;
    font-family: sans-serif;
    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 23px;
      height: 23px;
      color: #fff;
      text-align: center;
      background: url(~@/assets/img/dot_more.png) 50% 50% no-repeat;
    }
  }
  &__item:first-child {
    width: 104px;
    margin-left: -18px;
    @media only screen and (max-width: 1439px) and (min-width: 1081px){
      width: calc(((104 / 1440) * 100) * 1vw);
      margin-left: calc(((-18 / 1440) * 100) * 1vw);
    }
    #{$map-continent}__anchor {
      position: absolute;
      height: 60px;
      z-index: 1;
      top: -14px;
      @media only screen and (max-width: 1439px) and (min-width: 1081px){
        height: calc(((60 / 1440) * 100) * 1vw);
        top: calc(((-14 / 1440) * 100) * 1vw);
      }
    }
    #{$map-continent}__anchor:hover {
      cursor: pointer;
      transform: scale(1.26);
    }
  }
  &__thumbnail {
    width: 100%;
    height: 100%;
  }
}


</style>
